import { useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CalendarCheck } from "lucide-react";

// 342: zakázku nejde ukončit s nedokončenými fázemi harmonogramu — server vrátí 409
// `open_phases`; tady se uživatel rozhodne: označit je jako hotové a ukončit, nebo zpět.
// run(call): call(extra) je volání API; po potvrzení se zopakuje s { close_open_phases: true }.
// Zrušení vyhodí chybu s `cancelled`, ať volající vrátí zakázku tam, kde byla.
export function useOpenPhasesGuard() {
  const [info, setInfo] = useState(null);
  const answer = useRef(null);

  const close = (ok) => { answer.current?.(ok); answer.current = null; setInfo(null); };
  const run = async (call) => {
    try {
      return await call({});
    } catch (e) {
      const d = e.response?.status === 409 ? e.response?.data?.detail : null;
      if (!d || d.code !== "open_phases") throw e;
      const ok = await new Promise((resolve) => { answer.current = resolve; setInfo(d); });
      if (!ok) { const c = new Error("cancelled"); c.cancelled = true; throw c; }
      return call({ close_open_phases: true });
    }
  };

  const n = info?.count || 0;
  const rest = n - (info?.names || []).length;
  const word = n === 1 ? "nedokončenou fázi" : n < 5 ? "nedokončené fáze" : "nedokončených fází";
  const dialog = (
    <Dialog open={!!info} onOpenChange={(o) => { if (!o) close(false); }}>
      <DialogContent className="max-w-md" data-testid="open-phases-dialog">
        <span className="w-11 h-11 rounded-full bg-brand/10 text-brand grid place-items-center" aria-hidden="true"><CalendarCheck size={20} /></span>
        <DialogTitle className="text-lg font-bold">Ukončit zakázku?</DialogTitle>
        <DialogDescription className="text-sm text-muted-foreground">
          Zakázka má {n} {word} harmonogramu. Při ukončení je označíme jako hotové, ať nesvítí v „Co hoří“.
        </DialogDescription>
        <ul className="text-sm space-y-1 rounded-[12px] bg-secondary px-3.5 py-2.5" data-testid="open-phases-list">
          {(info?.names || []).map((name, i) => <li key={i} className="truncate">• {name}</li>)}
          {rest > 0 && <li className="text-muted-foreground">{`a ${rest} ${rest < 5 ? "další" : "dalších"}`}</li>}
        </ul>
        <div className="flex flex-col-reverse md:flex-row md:justify-end gap-2 pt-1">
          <Button variant="ghost" onClick={() => close(false)} className="w-full md:w-auto h-11" data-testid="open-phases-cancel">Zpět</Button>
          <Button onClick={() => close(true)} className="w-full md:w-auto h-11 font-bold" data-testid="open-phases-confirm">Označit jako hotové a ukončit</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
  return { run, dialog };
}
